import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ChakraProvider, extendTheme} from "@chakra-ui/react";

import App from "./components/app";

const themeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
}
const theme = extendTheme({ themeConfig })

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
